// extracted by mini-css-extract-plugin
module.exports = {"onlineToolsTeaserBackground":"OnlineToolsTeaser_onlineToolsTeaserBackground__NDGWj","onlineToolsTeaserBulletList":"OnlineToolsTeaser_onlineToolsTeaserBulletList__hhXVe"};